import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, StarIcon, UsersIcon, MapPinIcon, CreditCardIcon } from 'lucide-react';
export function Hero() {
  return <section className="pt-6 pb-10 md:pt-12 md:pb-20 px-4 md:px-8 max-w-4xl mx-auto overflow-hidden" data-id="element-135">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6,
      ease: 'easeOut'
    }} className="flex flex-col items-center text-center" data-id="element-136">
        {/* Eyebrow tags */}
        <div className="flex flex-wrap justify-center gap-2 mb-4 md:mb-6" data-id="element-137">
          <span className="bg-cream-dark text-teal-900 text-[10px] md:text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider" data-id="element-138">
            Egresadas · &lt;3 años de experiencia
          </span>
        </div>

        {/* Headline */}
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold leading-[1.1] mb-6 md:mb-8 text-teal-900 max-w-3xl" data-id="element-139">
          Todo tu año de Consulta Fonoaudiológica Infantil Resuelto
        </h1>

        {/* Mockup image at 70% */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7,
        delay: 0.2,
        ease: 'easeOut'
      }} className="relative w-[70%] max-w-md mb-2 md:mb-3" data-id="element-140">
          <div className="absolute inset-0 bg-teal-900/5 rounded-full blur-3xl transform scale-90" data-id="element-141"></div>
          <img src="https://cdn.magicpatterns.com/uploads/k3Cy6jdEe3KgFuCK7ktzLo/mockup_sin_fondo.png" alt="Kit de Evaluación Fonoaudiológica Infantil - mockup mostrando los 8 tomos" width="600" height="600" loading="eager" decoding="async"
        // @ts-ignore - fetchpriority is valid HTML5
        fetchpriority="high" className="w-full h-auto relative z-10 drop-shadow-2xl" data-id="element-142" />
        </motion.div>

        {/* Small product structure caption */}
        <p className="md:text-xs text-slate-500 font-medium uppercase tracking-wider mb-5 md:mb-8 text-[8px]" data-id="element-143">
          Kit de Evaluación Fonoaudiológica Infantil — 8 Tomos + 3 Bonos
        </p>

        {/* Subtitle */}
        <p className="text-base md:text-lg text-slate-600 mb-6 md:mb-8 max-w-2xl leading-relaxed" data-id="element-144">
          Tu sistema clínico completo listo: anamnesis, selección de
          instrumentos, protocolos de sesión, informes, devolución a familias y
          gestión del consultorio. Sin improvisar.
        </p>

        {/* CTA */}
        <button onClick={() => document.getElementById('pricing')?.scrollIntoView({
        behavior: 'smooth'
      })} className="w-full sm:w-auto bg-terracotta hover:bg-terracotta-hover active:scale-[0.98] text-white font-bold text-base md:text-lg py-3.5 md:py-4 px-6 md:px-8 rounded-lg shadow-lg hover:shadow-xl transition-all md:hover:-translate-y-1 flex items-center justify-center gap-2" data-id="element-145">
          <span className="text-xl" data-id="element-146">💥</span> QUIERO MI EVALUACIÓN RESUELTA
        </button>

        {/* Trust row */}
        <div className="mt-5 md:mt-8 flex flex-wrap items-center justify-center gap-x-4 md:gap-x-6 gap-y-2 text-xs md:text-sm text-slate-500 font-medium" data-id="element-147">
          <div className="flex items-center gap-1.5" data-id="element-148">
            <ShieldCheckIcon size={16} className="text-teal-700" data-id="element-149" />
            <span data-id="element-150">Garantía 7 días</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-151">
            <CreditCardIcon size={16} className="text-teal-700" data-id="element-152" />
            <span data-id="element-153">Pago seguro Mercado Pago</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-154">
            <UsersIcon size={16} className="text-teal-700" data-id="element-155" />
            <span data-id="element-156">+300 Fonoaudiólogas</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-157">
            <div className="flex text-amber-400" data-id="element-158">
              {[...Array(5)].map((_, i) => <StarIcon key={i} size={14} fill="currentColor" data-id="element-159" />)}
            </div>
            <span data-id="element-160">4.9 Rating</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-161">
            <MapPinIcon size={16} className="text-teal-700" data-id="element-162" />
            <span data-id="element-163">Todo Argentina</span>
          </div>
        </div>
      </motion.div>
    </section>;
}